import React from 'react';
import PropTypes from 'prop-types';
import ReactTable from 'react-table';
import Money from '../../../../common/money';
import { t } from '../../../../../modules/infra/i18n';

const List = ({ report, tipReport, history }) => {
  const columns = [{
    Header: '',
    accessor: 'name',
    className: 'u-text-center',
  }, {
    Header: t('barber:reports.payout.list.total_collected'),
    accessor: 'total',
    className: 'u-text-center',
    Cell: props => <Money cents={props.value} />,
  }, {
    Header: t('barber:reports.payout.list.credit_card_fees'),
    accessor: 'creditCardFees',
    className: 'u-text-center',
    Cell: props => <Money cents={props.value} />,
  }, {
    Header: t('barber:reports.payout.list.net_collected'),
    accessor: 'netCollected',
    className: 'u-text-center',
    Cell: props => <Money cents={props.value} />,
  }, {
    Header: t('barber:reports.payout.list.commission_percent'),
    accessor: 'percentage',
    className: 'u-text-center',
  }, {
    Header: t('barber:reports.payout.list.commission_due'),
    accessor: 'commission',
    className: 'u-text-center',
    Cell: props => <Money cents={props.value} />,
  }, {
    Header: t('barber:reports.payout.list.cash_retained'),
    accessor: 'cashRetained',
    className: 'u-text-center',
    Cell: props => <Money cents={props.value} />,
  }, {
    Header: history ? t('barber:reports.payout.list.transferred') : t('barber:reports.payout.list.to_be_transferred'),
    accessor: 'commissionDue',
    className: 'u-text-center',
    Cell: props => <Money cents={props.value} />,
  }];

  if (history) {
    columns.push({
      Header: t('barber:reports.payout.list.rapid_transfer_fees'),
      accessor: 'instantPayoutFee',
      className: 'u-text-center',
      Cell: props => <Money cents={props.value} />,
    }, {
      Header: t('barber:reports.payout.list.deposited'),
      accessor: 'commissionDeposited',
      className: 'u-text-center',
      Cell: props => <Money cents={props.value} />,
    });
  }

  return (
    <div>
      <h4>{t('barber:reports.payout.list.commission_heading')}</h4>
      <ReactTable
        minRows={0}
        showPagination={false}
        className="c-table-new c-table--small c-no-hover c-table--border"
        columns={columns}
        data={report}
      />
      <h4 className="u-mt">{t('barber:reports.payout.list.tips_heading')}</h4>
      <ReactTable
        minRows={0}
        showPagination={false}
        className="c-table-new c-table--small c-no-hover c-table--border"
        columns={[{
          Header: '',
          accessor: 'name',
          className: 'u-text-center',
        }, {
          Header: t('barber:reports.payout.list.tips'),
          accessor: 'totalCollected',
          className: 'u-text-center',
          Cell: props => <Money cents={props.value} />,
        }, {
          Header: t('barber:reports.payout.list.cash_tip'),
          accessor: 'cashTipAmount',
          className: 'u-text-center',
          Cell: props => <Money cents={props.value} />,
        }, {
          Header: t('barber:reports.payout.list.fees'),
          id: 'fees',
          accessor: row => row.creditCardFee + row.instantPayoutFee,
          className: 'u-text-center',
          Cell: props => <Money cents={props.value} />,
        }, {
          Header: t('barber:reports.payout.list.tips_deposited'),
          accessor: 'totalDeposited',
          className: 'u-text-center',
          Cell: props => <Money cents={props.value} />,
        }]}
        data={tipReport}
      />
    </div>
  );
};

List.propTypes = {
  history: PropTypes.bool,
};
List.defaultProps = {
  history: false,
};

export default List;
